import { Keyring } from '@polkadot/api';
import { u8aToHex } from '@polkadot/util';

function decodeAddress(publicKey) {
    return u8aToHex(new Keyring().decodeAddress(publicKey));
}
function encodeAddress(publicKeyRaw) {
    return new Keyring().encodeAddress(publicKeyRaw);
}

export { decodeAddress, encodeAddress };
